const l={install:(l,t)=>{const{hljs:e}=t;l.directive("highlight",(l=>{const t=l.querySelectorAll("pre code");Array.prototype.forEach.call(t,e.highlightBlock)}))}};export default l;
